// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"sales-pilot-sites-production-release@2026-07-01T23:00:57.475Z"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { init } from '@sentry/nextjs';
import { getBaseSentryClientConfig } from '@qb/base-config/base-sentry.client.config';

init({
  ...getBaseSentryClientConfig(false),
});
